import React from 'react';
import FullServices from './FullServices/FullServices';

const Services = () => {
    return (
        <div className='container'>
            <h1>Our Services</h1>
            <hr />
            <FullServices></FullServices>
        </div>
    );
};

export default Services;